<template>
  <div>
    <suggest-item v-for="item in suggestions" :key="item.id" :comment="item" btn-txt="reply"
                  @submitData="submitReplyData" :parent-id="item.id">
      <template slot="replay">
        <suggest-item v-for="reply in item.replys" :parent-id="item.id"
                      @submitData="submitReplyData" :key="reply.id" :comment="reply" btn-txt="reply"></suggest-item>
      </template>
    </suggest-item>
    <div style="height: 200px">

    </div>
    <v-loading :show="loading"></v-loading>
  </div>
</template>

<script>
import SuggestItem from "./SuggestItem.vue";
import util from "../util/util";
import VLoading from "../public/v-loading.vue";

export default {
  name: "forumIssueList",
  components: {VLoading, SuggestItem},
  props: {
    suggestType: String
  },
  data() {
    return {
      loading: false,
      suggestions: [],
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    submitReplyData: function (retData) {
      var _ = this;
      this.loading = true;
      this.$axios.post("/suggestion/submit", {postData: JSON.stringify(retData)}).then(function (res) {
        console.log(res);
        _.$Message.success("submit success");
        _.initPage();

      }).catch(function (res) {
        console.log(res);
        _.$Message.error("something error");
      }).finally(function () {
        _.loading = false;
      });
    },
    initPage: function () {
      if (util.isNull(this.suggestType)) {
        return;
      }
      var _ = this;
      this.$axios.post("/suggestion/init", {flag: this.suggestType}).then(function (res) {
        _.suggestions = res.data.suggestions;
        _.suggestions.forEach(sug => sug.score = parseFloat(sug.score))
      }).catch(function (res) {
        console.log(res);
      });
    },
  },
  watch: {
    suggestType() {
      this.initPage();
    }
  }
}
</script>

<style scoped>

</style>